import { Component, DestroyRef, Inject } from '@angular/core';
import { IconComponent } from '../../../../../shared/components/ui/icon/icon.component';
import { TranslatePipe } from '../../../../../shared/pipes/translate/translate.pipe';
import { Dialog, DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { OrgChartComponent } from '../../../org-chart/org-chart.component';
import { EditorModule } from '@progress/kendo-angular-editor';
import { BehaviorSubject, take } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { JsonPipe } from '@angular/common';
import { Store } from '@ngrx/store';
import { TaskApiService } from '../../../../../api/bizzmine/task/task-api.service';
import { OrgChartSelectComponent } from '../../../org-chart/org-chart-select/org-chart-select.component';
import { OrgChartItem } from '../../../org-chart/interfaces/org-chart-item';
import { OrganizationChartItemType } from 'src/models/ts/organization-chart-item-type.model';
import { TextAreaModule } from '@progress/kendo-angular-inputs';
import { LoaderButtonComponent } from '../../../../../shared/components/loader-button/loader-button/loader-button.component';
import { formsActions } from '../../../../../store/features/forms/forms-actions';
import { selectFormByTaskId } from '../../../../../store/features/forms/forms-selectors';
import { refreshActions } from '../../../../../store/features/refresh/refresh-actions';
import { AlertService } from '../../../alerts/alert.service';
import { TranslationService } from 'src/app/core/services/translation/translation.service';

@Component({
  selector: 'bizz-task-forward-dialog',
  standalone: true,
  imports: [
    IconComponent,
    TranslatePipe,
    OrgChartComponent,
    EditorModule,
    JsonPipe,
    OrgChartSelectComponent,
    TextAreaModule,
    LoaderButtonComponent
  ],
  templateUrl: './task-forward-dialog.component.html',
  styleUrl: './task-forward-dialog.component.scss'
})
export class TaskForwardDialogComponent {
  public excludedUserIds: Array<number> = [];
  public selectedOrgChatItem: OrgChartItem | null = null;
  public selectedOrgChartItems$ = new BehaviorSubject<Array<OrgChartItem>>([]);
  public forwardingReason: string = '';
  public loading = false;
  public isValid = false;
  protected OrganizationChartItemType = OrganizationChartItemType;

  public constructor(private dialogRef: DialogRef<TaskForwardDialogComponent>, private destroyRef: DestroyRef,
                     @Inject(DIALOG_DATA) public data: { taskId: number, collectionId: number, assignedToId: number },
                     private dialog: Dialog,
                     private store$: Store,
                     private taskApiService: TaskApiService,
                     private alertService: AlertService,
                     private translationService: TranslationService) {
    this.excludedUserIds = [this.data.assignedToId];
    this.selectedOrgChartItems$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((items) => {
      if (items.length > 0) {
        this.selectedOrgChatItem = items[0];
      } else {
        this.selectedOrgChatItem = null;
      }
      this.validate();
    });
  }

  public close(): void {
    this.dialogRef.close();
  }

  public validate(): boolean {
    this.isValid = this.selectedOrgChatItem != null && this.forwardingReason.trim().length > 0;
    return this.isValid;
  }

  public forwardTask(): void {
    if (this.loading || !this.validate()) {
      return;
    }
    this.loading = true;
    this.taskApiService.forwardTask({
      task: {
        TasksID: this.data.taskId,
        CurrentUsersID: this.data.assignedToId,//this.store$.selectSignal(userSettingsFeature.selectUserID)(),
        Reason: this.forwardingReason,
        SelectedOrganizationChartItems: [this.selectedOrgChatItem!] // TODO -> add orgChartItem
      }
    }).pipe(take(1)).subscribe({
      next: () => {
        this.loading = false;
        const form = this.store$.selectSignal(selectFormByTaskId(this.data.taskId))();
        if (form != undefined) {
          this.store$.dispatch(formsActions.saveTask({
            formId: form!.id,
            closeForm: true,
            preValidate: false
          }));
        }
        this.store$.dispatch(refreshActions.refreshData({
          all: true
        }));
        this.close();
      },
      error: (err) => {
        this.loading = false;
        this.alertService.setAlert({
          type: 'warning',
          content: err?.error?.Errors?.map((err: { Key: string, Message: string }) => err.Message) ?? [],
          title: '',
          icon: 'triangle-exclamation',
          dismissable: true,
          timed: false
        });
        this.store$.dispatch(refreshActions.refreshData({
          all: true
        }));
        this.close();
      }
    });


  }

}
